import {AbstractReactComponent, i18n, Icon} from 'mc/lib';
import React from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {browserHistory} from 'react-router';
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row} from 'reactstrap';
import {UserActions} from '../actions';
import {Api} from '../api';
import {Loading} from '../components';

class Layout extends AbstractReactComponent {

    state = {
        navbarOpen: false
    };

    componentDidMount() {
        if (window.location.hash === "#firstLogin") {
            setTimeout(this.showFirstLoginMessage, 2000);
            window.location.hash = '';
        }
        this.dispatch(UserActions.fetchIfNeeded());
    };

    componentWillUnmount() {
        this.dispatch(UserActions.invalidate());
    }

    showFirstLoginMessage = () => {
        toastr.info('', {
            component: (
                <a className="text-white" href="#" onClick={this.navigateToUserProfilePage}>
                    {i18n('toastr.clickToEditProfile')}
                </a>
            )
        });
    };

    logout = () => {
        Api.logout().then(() => {
            this.navigateTo('/welcome');
        });
    };

    navigateToRootPage = () => {
        this.closeNavbar();
        this.navigateTo('');
    };

    navigateToUserProfilePage = () => {
        this.closeNavbar();
        this.navigateTo('/user/profile');
    };

    navigateTo(path) {
        browserHistory.push(serverContextPath + path);
    }

    closeNavbar() {
        this.setState({navbarOpen: false});
    }

    toggleNavbar = () => {
        this.setState({navbarOpen: !this.state.navbarOpen});
    };

    render() {
        const {children, user, route} = this.props;
        if (!user.data) {
            return <Loading block="full"/>;
        }
        return <div>
            <Row>
                <Navbar id="header" inverse fixed="top" toggleable="md">
                    <NavbarBrand href="javascript:void(0)" onClick={this.navigateToRootPage}>
                        {route.path
                            ? <span>Seznam žádostí</span>
                            : window.APP_TITLE}
                    </NavbarBrand>
                    <NavbarToggler right onClick={this.toggleNavbar}/>
                    <Collapse isOpen={this.state.navbarOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            {window.MAP_URL && (
                                <NavItem >
                                    <NavLink href={window.MAP_URL}>Přehledová mapa</NavLink>
                                </NavItem>
                            )}
                            <NavItem>
                                <NavLink href="#" onClick={this.navigateToRootPage}>{user.data.loginName}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" onClick={this.navigateToUserProfilePage}>Upravit profil</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#" onClick={this.logout}>Odhlásit</NavLink>
                            </NavItem>
                            {window.HELP_URL && (
                                <NavItem>
                                    <NavLink href={window.HELP_URL} target="_blank">
                                        <Icon icon="question-circle"/>
                                    </NavLink>
                                </NavItem>
                            )}
                        </Nav>
                    </Collapse>
                </Navbar>
            </Row>
            {children}
        </div>
    }
}

const mapStateToProps = state => ({
    user: state.app.user,
});

export default connect(mapStateToProps)(Layout);
